<template>
    <aside class="drawer" :class="{ 'drawer--collapsed': collapsed }">
        <div v-show="!collapsed" class="drawer__inner" @scroll="$emit('scroll', $event)">
            <slot></slot>
        </div>
        <div class="drawer__toggler-wrap">
            <button class="drawer__toggler" @click="toggle" />
        </div>
    </aside>
</template>

<script>
export default {
    name: 'Drawer',
    emits: ['scroll'],
    props: {
        storageKey: {
            type: String,
            default: 'navigation',
        },
    },
    data() {
        return {
            collapsed: true,
        };
    },
    watch: {
        collapsed() {
            if (this.collapsed) {
                localStorage.setItem(`${this.storageKey}-collapsed`, 'True');
            } else {
                localStorage.setItem(`${this.storageKey}-collapsed`, 'False');
            }
        },
    },
    mounted() {
        if (localStorage.getItem(`${this.storageKey}-collapsed`) === 'False') {
            this.collapsed = false;
        }
    },
    methods: {
        toggle() {
            this.collapsed = !this.collapsed;
        },
        collapse() {
            this.collapsed = true;
        },
        open() {
            this.collapsed = false;
        },
    },
};
</script>

<style src="./Drawer.scss" lang="scss"></style>
